import React from 'react';
import Login from './Login';

export default function PrivateRoute({ component: Component }) {
  const isAuthenticated = sessionStorage.getItem('mindmapAuthenticated') === 'true';

  if (!isAuthenticated) {
    return <Login />;
  }

  return <Component />;
}